module.exports = __webpack_public_path__ + "img/3.d772b59a.png";